import { onMessage } from "firebase/messaging";
import { getFirebaseMessaging } from "../lib/firebase";

export const listenToForegroundMessages = async (onNotification) => {
  const messaging = await getFirebaseMessaging();
  if (!messaging) return;

  return onMessage(messaging, (payload) => {
    console.log("Foreground message:", payload);

    const data = payload.data || {};
    const title =
      payload.notification?.title ||
      data.title ||
      data.notificationTitle ||
      data.subject ||
      "New notification";
    const body =
      payload.notification?.body ||
      data.body ||
      data.message ||
      data.description ||
      data.notificationBody ||
      "";

    if (onNotification) {
      onNotification({ title, body, payload });
    }

    if (Notification.permission === "granted" && title) {
      new Notification(title, {
        body,
      });
    }
  });
};
